import React, { FC } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { CssBaseline } from "@mui/material";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { SnackbarProvider } from "notistack";
import { IntercomProvider } from "react-use-intercom";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { extend } from "dayjs";

extend(utc);
extend(timezone);
import { configureAxios, queryClient } from "./api/config";

import { router } from "@router";
import "./i18n";
import { ThemeProvider } from "@theme";
import { INTERCOM_APP_ID } from "@constants";

configureAxios();

const App: FC = () => {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <IntercomProvider appId={INTERCOM_APP_ID}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <RouterProvider {...{ router }} />
            <CssBaseline />
          </ThemeProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </IntercomProvider>
    </SnackbarProvider>
  );
};

export { App };
